// extracted by mini-css-extract-plugin
export default {"section":"Section_section__woRAq","container":"Section_container__1RrmY"};